// --------------------------------------- Project List
export const ProjectList = [
  {
    img: process.env.PUBLIC_URL + "/bot.png",
    title: "Virtual Defence System",
    description:
      "Virtual Defence System is an interactive web platform that allows users to locate nearest recovery stations, report incidents, and monitor security, combining real-time maps with AI-assisted features for enhanced safety.",
    tech_stack: ["React Js", "Google Cloud", "Firebase", "TailwindCSS"],
    github_url: "",
    demo_url: "https://hsnataleem.github.io/Virtual-defence",
  },
  {
    img: process.env.PUBLIC_URL + "/renr-responsive.png",
    title: "RENR Safety App",
    description:
      "A safety application for the Renewable Resources",
    tech_stack: ["React", "Firebase"],
    github_url: "",
    demo_url: "https://renr-bcit.web.app/",
  },
  {
    img: process.env.PUBLIC_URL + "/file-fly.png",
    title: "File Fly",
    description:
      "A secure and efficient file-sharing platform that allows users to share files over the internet using QR code scanning or direct links across multiple devices.",
    tech_stack: ["React", "Vite", "Node.js", "Express", "Render", "GitHub"],
    github_url: "https://github.com/hsnataleem/File-Fly",
    demo_url: "https://hsnat.me",
  },
  /*
  {
    img: "/mymind-responsive.png",
    title: "MyMind",
    description:
      "An app where users can purchase online therapy sessions and chat with their therapists.",
    tech_stack: ["HTML", "CSS", "NodeJs", "MongoDB", "SocketIo"],
    github_url: "https://github.com/salesp07/MyMind---Copy",
    demo_url: "https://mymindweb.vercel.app/",
  },
  {
    img: "/pokedex-responsive.png",
    title: "Pokedex",
    description:
      "A pokedex app that displays pokemon data, plays OSTs and makes pokemons dance.",
    tech_stack: ["ReactJs", "NodeJs", "MongoDB"],
    github_url: "https://github.com/salesp07/Pokedex-ReactApp",
    demo_url: "https://pokedex-salesp07.netlify.app/",
  },
  {
    img: "/jobDetect.png",
    title: "JobDetect",
    description:
      "An app to detect if a job posting is a scam or not using its description.",
    tech_stack: ["Python", "Flask", "NodeJs", "MongoDB"],
    github_url: "https://github.com/salesp07/JobDetectNode",
    demo_url: "https://jobdetective.onrender.com/",
  },
  */
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },

  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "React Native",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
    name: "Firebase",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    name: "Python",
  },

  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    name: "C",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    name: "Java",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "Bootstrap",
  },

  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original.svg",
    name: "Express",
  },

];
